(() => {
  // runtime/circuit-v2/assets/glyphs.json
  var glyphs_default = { "0": ["01110", "10001", "10011", "10101", "11001", "10001", "01110"], "1": ["00100", "01100", "00100", "00100", "00100", "00100", "01110"], "2": ["01110", "10001", "00001", "00010", "00100", "01000", "11111"], "3": ["11110", "00001", "00001", "01110", "00001", "00001", "11110"], "4": ["00010", "00110", "01010", "10010", "11111", "00010", "00010"], "5": ["11111", "10000", "10000", "11110", "00001", "00001", "11110"], "6": ["01110", "10000", "10000", "11110", "10001", "10001", "01110"], "7": ["11111", "00001", "00010", "00100", "01000", "01000", "01000"], "8": ["01110", "10001", "10001", "01110", "10001", "10001", "01110"], "9": ["01110", "10001", "10001", "01111", "00001", "00001", "01110"], A: ["01110", "10001", "10001", "11111", "10001", "10001", "10001"], B: ["11110", "10001", "10001", "11110", "10001", "10001", "11110"], C: ["01111", "10000", "10000", "10000", "10000", "10000", "01111"], D: ["11110", "10001", "10001", "10001", "10001", "10001", "11110"], E: ["11111", "10000", "10000", "11110", "10000", "10000", "11111"], F: ["11111", "10000", "10000", "11110", "10000", "10000", "10000"], G: ["01111", "10000", "10000", "10111", "10001", "10001", "01110"], H: ["10001", "10001", "10001", "11111", "10001", "10001", "10001"], I: ["11111", "00100", "00100", "00100", "00100", "00100", "11111"], J: ["00111", "00010", "00010", "00010", "10010", "10010", "01100"], K: ["10001", "10010", "10100", "11000", "10100", "10010", "10001"], L: ["10000", "10000", "10000", "10000", "10000", "10000", "11111"], M: ["10001", "11011", "10101", "10101", "10001", "10001", "10001"], N: ["10001", "11001", "11001", "10101", "10011", "10011", "10001"], O: ["01110", "10001", "10001", "10001", "10001", "10001", "01110"], P: ["11110", "10001", "10001", "11110", "10000", "10000", "10000"], R: ["11110", "10001", "10001", "11110", "10100", "10010", "10001"], S: ["01111", "10000", "10000", "01110", "00001", "00001", "11110"], T: ["11111", "00100", "00100", "00100", "00100", "00100", "00100"], U: ["10001", "10001", "10001", "10001", "10001", "10001", "01110"], V: ["10001", "10001", "10001", "10001", "10001", "01010", "00100"], W: ["10001", "10001", "10001", "10101", "10101", "11011", "10001"], X: ["10001", "10001", "01010", "00100", "01010", "10001", "10001"], Y: ["10001", "10001", "01010", "00100", "00100", "00100", "00100"], Z: ["11111", "00001", "00010", "00100", "01000", "10000", "11111"], "/": ["00001", "00001", "00010", "00100", "01000", "10000", "10000"], ".": ["00000", "00000", "00000", "00000", "00000", "00100", "00100"], "\xB7": ["00000", "00000", "00000", "00100", "00000", "00000", "00000"], " ": ["00000", "00000", "00000", "00000", "00000", "00000", "00000"] };

  // runtime/circuit-v2/palette.mjs
  function preparePalette(assets2, makeCanvas) {
    for (const name of ["hills", "landmarks", "trees", "upper-verge", "lower-verge", "pale", "grey"]) {
      const img = assets2[name], canvas2 = makeCanvas(img.width, img.height), ctx2 = canvas2.getContext("2d");
      ctx2.drawImage(img, 0, 0);
      const data = ctx2.getImageData(0, 0, img.width, img.height);
      for (let i = 0; i < data.data.length; i += 4) {
        const p = data.data;
        if (!p[i + 3]) continue;
        let grey = Math.round(p[i] * 0.2126 + p[i + 1] * 0.7152 + p[i + 2] * 0.0722);
        if (grey < 34) grey = 27;
        p[i] = p[i + 1] = p[i + 2] = grey;
      }
      ctx2.putImageData(data, 0, 0);
      assets2[name] = canvas2;
    }
    return assets2;
  }

  // runtime/circuit-v2/model.mjs
  var W = 2752;
  var H = 1536;
  var BASE_SPEED = 1920;
  var BOOST_SPEED = 4800;
  var LANES = [756, 924, 1092];
  var BOOST_SECONDS = 1.6;
  var BOOST_CYCLE = 4.6;
  var SECTORS = ["COTA ESSES", "GRANDSTAND", "TOWER RUN", "FINAL STRAIGHT"].map((name) => ({ name, length: 25920 }));
  function cruiseSpeed(s) {
    return BASE_SPEED * (1 + 0.45 * Math.log1p(Math.max(0, s.time) / 30));
  }
  var TRAFFIC_PACE = 0.72;
  var OPEN_LANES = [1, 0, 1, 2];
  var SPAWN_X = W + 420;
  function trafficPressure(s) {
    return Math.min(1, (cruiseSpeed(s) / BASE_SPEED - 1) / 0.65);
  }
  function trafficGap(s) {
    const closing = cruiseSpeed({ time: s.time + 12 }) * (BOOST_SPEED / BASE_SPEED - TRAFFIC_PACE);
    return 1104 + 72 + closing * 0.7 + 800 * (1 - trafficPressure(s));
  }
  function addTrafficWave(s, x) {
    const wave = s.spawnCount++, openLane = OPEN_LANES[wave % OPEN_LANES.length];
    const lanes = [0, 1, 2].filter((lane) => lane !== openLane);
    s.trafficPairs += 0.08 + 0.77 * trafficPressure(s);
    const paired = s.trafficPairs >= 1;
    if (paired) s.trafficPairs -= 1;
    for (const lane of paired ? lanes : [lanes[wave % 2]]) s.opponents.push({ name: (wave + lane) % 2 ? "grey" : "pale", x, y: LANES[lane], pace: TRAFFIC_PACE, speed: cruiseSpeed(s) * TRAFFIC_PACE, distance: 0, wave, openLane });
    s.lastWaveX = x;
  }
  function createState(options = {}) {
    const s = { time: 0, distance: 0, speed: BASE_SPEED, boostUntil: 0, cooldownUntil: 0, paused: !!options.paused, demo: options.demo !== false, lane: 1, y: LANES[1], laneFrom: LANES[1], laneStart: -1, boostAmount: 0, playerX: 900, sector: 0, sectorStart: 0, sectorDistance: 0, cleared: 0, boosts: 0, phase: "Cruise", status: "racing", crashAt: null, crashX: 0, crashY: 0, crashCar: null, noticeUntil: 0, spawnCount: 0, trafficEnabled: options.traffic !== false, trafficPairs: 0, trafficHoldUntil: 0, lastWaveX: 2250, opponents: [] };
    if (s.trafficEnabled) addTrafficWave(s, 2250);
    return s;
  }
  function steer(s, delta, manual = true) {
    if (s.paused || s.status !== "racing") return false;
    if (manual) s.demo = false;
    const lane = Math.max(0, Math.min(2, s.lane + delta));
    if (lane === s.lane) return false;
    s.laneFrom = s.y;
    s.laneStart = s.time;
    s.lane = lane;
    return true;
  }
  function boost(s, manual = true) {
    if (s.paused || s.status !== "racing" || s.time < s.cooldownUntil) return false;
    if (manual) s.demo = false;
    s.boostUntil = s.time + BOOST_SECONDS;
    s.cooldownUntil = s.time + BOOST_CYCLE;
    s.boosts++;
    if (s.trafficEnabled) {
      s.trafficHoldUntil = s.boostUntil + 0.6;
      const hidden = s.opponents.filter((o) => o.x >= W);
      if (hidden.length) {
        const shift = Math.max(0, SPAWN_X - Math.min(...hidden.map((o) => o.x)));
        for (const o of hidden) {
          o.x += shift;
          o.heldUntil = s.trafficHoldUntil;
        }
        s.lastWaveX += shift;
      }
    }
    return true;
  }
  function setPaused(s, value) {
    s.paused = value;
  }
  function boostStatus(s) {
    return s.status !== "racing" ? "OFF" : s.time < s.boostUntil ? "LIVE" : s.time < s.cooldownUntil ? "WAIT" : "READY";
  }
  function remaining(s) {
    return Math.max(0, SECTORS[s.sector].length - (s.distance - s.sectorDistance));
  }
  function hit(s, o) {
    return Math.abs(s.playerX - o.x) < 552 && Math.abs(s.y - o.y) < 78;
  }
  function crash(s, o) {
    s.status = "crashing";
    s.crashAt = s.time;
    s.crashX = s.playerX;
    s.crashY = s.y;
    s.crashCar = o;
    s.boostUntil = 0;
    s.phase = "Contact";
  }
  function crashPreview() {
    const s = createState({ demo: false, traffic: false });
    s.previewCrash = true;
    s.opponents = [{ name: "pale", x: 1700, y: LANES[1], speed: BASE_SPEED * 0.5, distance: 0 }];
    boost(s, false);
    return s;
  }
  function autopilot(s) {
    const base = cruiseSpeed(s), speed = Math.max(s.speed, base);
    const danger = (lane, pace, horizon) => s.opponents.some((o) => {
      if (Math.abs(o.y - LANES[lane]) >= 78) return false;
      const start2 = o.x - s.playerX, end = start2 + (o.speed - pace) * horizon;
      return Math.min(start2, end) < 650 && Math.max(start2, end) > -650;
    });
    if (danger(s.lane, speed, BOOST_SECONDS + 0.8) && s.time - s.laneStart > 0.35) {
      for (const delta of [-1, 1]) if (s.lane + delta >= 0 && s.lane + delta < 3 && !danger(s.lane + delta, speed, 0.55)) {
        steer(s, delta, false);
        break;
      }
    }
    if (s.time > 1 && s.time >= s.cooldownUntil && s.time - s.laneStart > 0.35 && !danger(s.lane, base * BOOST_SPEED / BASE_SPEED, BOOST_SECONDS + 0.4)) boost(s, false);
  }
  function advance(s, dt) {
    s.time += dt;
    if (s.status === "crashing") {
      const age = s.time - s.crashAt;
      s.speed *= Math.exp(-dt / 0.24);
      s.distance += s.speed * dt;
      s.playerX = s.crashX - 72 * (1 - Math.exp(-age * 4));
      s.y = s.crashY + Math.sin(age * 5) * Math.exp(-age * 3) * 12;
      s.boostAmount *= Math.exp(-dt / 0.08);
      if (age >= 1.35) {
        s.status = "crashed";
        s.speed = 0;
        s.phase = "Contact \u2014 restart to race again";
      }
      return;
    }
    if (s.demo) autopilot(s);
    const base = cruiseSpeed(s), active = s.time < s.boostUntil;
    s.speed += ((active ? base * BOOST_SPEED / BASE_SPEED : base) - s.speed) * (1 - Math.exp(-dt / (active ? 0.12 : 0.3)));
    s.boostAmount += ((active ? 1 : 0) - s.boostAmount) * (1 - Math.exp(-dt / 0.16));
    s.playerX = 900 + 72 * s.boostAmount;
    s.distance += s.speed * dt;
    const t = Math.min(1, Math.max(0, (s.time - s.laneStart) / 0.3));
    s.y = s.laneFrom + (LANES[s.lane] - s.laneFrom) * t * t * (3 - 2 * t);
    const traffic = [...s.opponents].sort((a, b) => b.x - a.x);
    for (const o of traffic) {
      if (s.time < (o.heldUntil ?? 0)) continue;
      o.speed = base * (o.pace ?? (o.name === "pale" ? 0.68 : 0.8));
      const ahead = traffic.filter((p) => p !== o && p.y === o.y && p.x > o.x).sort((a, b) => a.x - b.x)[0];
      if (ahead) o.speed = Math.min(o.speed, Math.max(0, s.speed + (ahead.x - o.x - 720) / dt));
      o.x += (o.speed - s.speed) * dt;
      o.distance += o.speed * dt;
      if (hit(s, o)) {
        crash(s, o);
        return;
      }
    }
    if (s.trafficEnabled) {
      const lastWave = s.opponents.find((o) => o.wave === s.spawnCount - 1);
      s.lastWaveX = lastWave ? lastWave.x : s.lastWaveX + (base * TRAFFIC_PACE - s.speed) * dt;
      s.opponents = s.opponents.filter((o) => o.x >= -720);
      if (s.time >= s.trafficHoldUntil && s.lastWaveX <= SPAWN_X - trafficGap(s)) addTrafficWave(s, SPAWN_X);
    }
    s.phase = active ? "Boost" : t < 1 ? "Lane change" : "Cruise";
    if (remaining(s) <= 0) {
      s.cleared++;
      s.noticeUntil = s.time + 1.5;
      s.sector = (s.sector + 1) % SECTORS.length;
      s.sectorStart = s.time;
      s.sectorDistance = s.distance;
    }
  }
  function step(s, dt) {
    if (s.paused || !["racing", "crashing"].includes(s.status)) return s;
    let left = Math.max(0, Math.min(0.1, dt));
    while (left > 1e-8 && ["racing", "crashing"].includes(s.status)) {
      const h = Math.min(left, 1 / 120);
      advance(s, h);
      left -= h;
    }
    return s;
  }

  // runtime/circuit-v2/car-profile.json
  var car_profile_default = {
    source: "User Aston Martin side-profile image; approximate landmarks measured on 2048px-wide display of 3200px original. This is a photographic projection, not an engineering orthographic drawing.",
    referenceWidth: 2048,
    referenceRearX: 1800,
    referenceGroundY: 790,
    scale: 0.09481668773704172,
    offsetX: 4,
    groundY: 47,
    wheels: [
      {
        cx: 24.480404551201012,
        cy: 36.854614412136534,
        r: 10.619469026548671
      },
      {
        cx: 124.32237673830593,
        cy: 36.71238938053097,
        r: 10.761694058154236
      }
    ]
  };

  // runtime/circuit-v2/renderer.mjs
  var BG = "#1b1b1b";
  var DOT = 2.2;
  var PITCH = 8;
  var palettes = { aston: { tyre: "#889b7e", lit: "#a2c99a" }, pale: { tyre: "#b8b8b8", lit: "#f1f1f1" }, grey: { tyre: "#888888", lit: "#bebebe" } };
  var rasterLevels = /* @__PURE__ */ new WeakMap();
  function minified(image, scale, document2) {
    const level = Math.max(0, Math.round(Math.log2(1 / scale)));
    if (!level) return image;
    let levels = rasterLevels.get(image);
    if (!levels) {
      levels = [image];
      rasterLevels.set(image, levels);
    }
    while (levels.length <= level) {
      const source = levels.at(-1), next = document2.createElement("canvas");
      next.width = Math.max(1, Math.round(source.width / 2));
      next.height = Math.max(1, Math.round(source.height / 2));
      next.getContext("2d").drawImage(source, 0, 0, next.width, next.height);
      levels.push(next);
    }
    return levels[level];
  }
  function draw(ctx2, assets2, s, width, height) {
    ctx2.imageSmoothingQuality = "high";
    ctx2.setTransform(width / W, 0, 0, height / H, 0, 0);
    ctx2.fillStyle = BG;
    ctx2.fillRect(0, 0, W, H);
    const drawAsset = (image, x, y) => ctx2.drawImage(minified(image, width / W, ctx2.canvas.ownerDocument), x, y, image.width, image.height);
    const dot = (x, y, color, alpha = 1) => {
      ctx2.globalAlpha = alpha;
      ctx2.fillStyle = color;
      ctx2.beginPath();
      ctx2.arc(x, y, DOT, 0, Math.PI * 2);
      ctx2.fill();
      ctx2.globalAlpha = 1;
    };
    function tile(img, y, rate, mirror = false) {
      const shift = s.distance * rate, first = Math.floor(shift / W), offset2 = shift % W;
      for (let i = 0; i < 2; i++) {
        const x = i * W - offset2;
        if (mirror && (first + i) % 2) {
          ctx2.save();
          ctx2.translate(x + W, 0);
          ctx2.scale(-1, 1);
          drawAsset(img, 0, y);
          ctx2.restore();
        } else drawAsset(img, x, y);
      }
    }
    tile(assets2.hills, 448, 0.055, true);
    tile(assets2.landmarks, 192, 0.13);
    tile(assets2.trees, 480, 0.23);
    for (let x = 4; x < W; x += PITCH) dot(x, 708, "#505050");
    tile(assets2["upper-verge"], 696, 1);
    tile(assets2["lower-verge"], 1304, 1);
    for (const y of [808, 1312]) for (let x = 20; x < W - 16; x += PITCH) dot(x, y, "#ababab");
    const offset = s.distance % 64;
    for (const y of [976, 1144]) for (let x = -64 - offset; x < W; x += 64) for (let j = 0; j < 4; j++) dot(x + j * 8, y, "#737373");
    function car(name, x, y, distance, player = false) {
      ctx2.save();
      if (player && s.crashAt !== null) {
        const age = s.time - s.crashAt;
        ctx2.translate(x + 304, y + 120);
        ctx2.rotate(-0.12 * Math.sin(Math.min(1, age / 0.8) * Math.PI / 2));
        ctx2.translate(-x - 304, -y - 120);
      }
      const p = palettes[name], bump = Math.sin(distance * 0.014) * 1.2;
      y += bump;
      ctx2.fillStyle = BG;
      ctx2.fillRect(x + 32, y + 38, 140, 30);
      if (player && s.boostAmount > 0.03) {
        for (let row = 0; row < 3; row++) {
          const length = 120 + s.boostAmount * 220, phase = (s.distance * 1.4 + row * 24) % 32;
          for (let dx = 0; dx < length; dx += 8) {
            if ((Math.floor((dx + phase) / 8) + row) % 4 === 0) continue;
            dot(x - dx, y + 138 + row * 14, "#4cc9e9", s.boostAmount * 0.5 * (1 - dx / length));
          }
        }
      }
      drawAsset(assets2[name], x, y);
      for (const wheel of car_profile_default.wheels) {
        const cx = wheel.cx * 3.8, cy = wheel.cy * 3.8, r = wheel.r * 3.8;
        const angle = distance / r, inner = r * 0.45, count = Math.max(8, Math.round(Math.PI * 2 * inner / PITCH));
        ctx2.fillStyle = "#222222";
        ctx2.beginPath();
        ctx2.arc(x + cx, y + cy, r * 0.71, 0, Math.PI * 2);
        ctx2.fill();
        dot(x + cx, y + cy, p.tyre);
        for (let i = 0; i < count; i++) {
          const a = (i + 0.5) * Math.PI * 2 / count + angle;
          dot(x + cx + Math.cos(a) * inner, y + cy + Math.sin(a) * inner, p.tyre, 0.65);
        }
        for (let spoke = 0; spoke < 3; spoke++) {
          const a = angle + spoke * Math.PI * 2 / 3;
          for (const length of [r * 0.22, r * 0.45]) dot(x + cx + Math.cos(a) * length, y + cy + Math.sin(a) * length, p.lit, 0.9);
        }
        for (let j = 0; j < 3; j++) {
          const a = angle + j * PITCH / r;
          dot(x + cx + Math.cos(a) * r, y + cy + Math.sin(a) * r, p.lit, 0.75);
        }
      }
      ctx2.restore();
    }
    const cars = s.opponents.map((o) => ({ ...o, player: false }));
    cars.push({ name: "aston", x: s.playerX, y: s.y, distance: s.distance, player: true });
    cars.sort((a, b) => a.y - b.y).forEach((o) => car(o.name, o.x, o.y, o.distance, o.player));
    if (s.crashAt !== null) {
      const age = s.time - s.crashAt, cx = s.crashX + 548, cy = s.crashY + 120, style = s.crashStyle || "smoke";
      if (style === "skid") {
        for (let i = 0; i < 38; i++) {
          const angle = i * 0.618 % 1 * Math.PI * 2, v = 80 + i % 7 * 30;
          dot(cx + Math.cos(angle) * v * age, cy + Math.sin(angle) * v * age + 110 * age * age, "#eeeeee", Math.max(0, 1 - age / 1.35));
        }
      } else {
        if (age < 0.17) for (let ray = 0; ray < 5; ray++) for (let r = 8; r < 48; r += 8) {
          const a = -Math.PI + ray * Math.PI / 4;
          dot(cx + Math.cos(a) * r, cy + Math.sin(a) * r, "#f1f1f1", 1 - age / 0.17);
        }
        const p = Math.max(0, (age - 0.09) / 0.95), radius = 38 + p * 62, rise = p * 140;
        if (p < 1) {
          for (let x = -136; x <= 144; x += 8) for (let y = -248; y <= 48; y += 8) {
            const lobes = [[-34, -rise, 1], [12, -rise - 34, 0.85], [56, -rise + 3, 0.7]];
            const inside = lobes.some(([lx, ly, scale]) => ((x - lx) / (radius * scale)) ** 2 + ((y - ly) / (radius * scale * 0.9)) ** 2 < 1);
            if (inside && (Math.round(x / 8) + Math.round(y / 8)) % 3 !== 0) dot(cx + x, cy + y, "#dddddd", 0.95 * (1 - p));
          }
        }
        if (style === "flare" && age < 0.62) {
          const flame = 1 - age / 0.62;
          for (let y = 0; y < 130 * flame; y += 8) for (let x = -40; x <= 40; x += 8) {
            if (Math.abs(x) < 44 - y * 0.3 && (x + y) % 16 === 0) dot(cx + x, cy - y, "#4cc9e9", flame);
            if (Math.abs(x) < 8 && y < 64 * flame) dot(cx + x, cy - y, "#f1f1f1", flame);
          }
        }
      }
      for (let x = 0; x < 120 * Math.min(1, age); x += 8) for (const y of [144, 168]) dot(s.crashX + 70 - x, s.crashY + y, "#777777", 0.5);
    }
    drawAsset(assets2["hud-top"], 0, 0);
    for (const y of [1408, 1528]) for (let x = 12; x < W; x += 8) dot(x, y, "#616161");
    function text(value, x, y, color) {
      [...value].forEach((ch, i) => (assets2.glyphs[ch] || assets2.glyphs[" "]).forEach((row, j) => [...row].forEach((on, k) => {
        if (on === "1") dot(x + i * 48 + k * 8, y + j * 8, color);
      })));
    }
    ctx2.fillStyle = BG;
    ctx2.fillRect(0, 0, W, 160);
    for (const y of [8, 152]) for (let x = 12; x < W; x += 8) dot(x, y, "#616161");
    text("COTA / 0" + (s.sector + 1), 24, 48, "#999999");
    text("LAP " + String(Math.floor(s.cleared / SECTORS.length) + 1).padStart(2, "0"), 740, 48, "#4cc9e9");
    text(Math.ceil(remaining(s) / 14) + " M TO GO", 1270, 48, "#f1f1f1");
    text(Math.round(s.speed / 7.2) + " KM/H", 2150, 48, "#888888");
    const progress = 1 - remaining(s) / SECTORS[s.sector].length;
    for (let x = 740; x < 2080; x += 8) dot(x, 124, x < 740 + 1340 * progress ? "#4cc9e9" : "#494949");
    const message = s.status === "crashed" ? "CONTACT" : s.time < s.noticeUntil ? s.sector === 0 ? "LAP CLEAR" : "AREA CLEAR" : "";
    if (message) {
      ctx2.fillStyle = BG;
      ctx2.fillRect(840, 244, 1120, 176);
      text(message, 1376 - message.length * 24, 272, "#4cc9e9");
      text(s.status === "racing" ? s.cleared < 5 ? "PACE UP" : "KEEP RACING" : "RESTART TO RACE", s.status === "racing" ? 1208 : 1040, 352, "#cccccc");
    }
  }

  // runtime/circuit-v2/app.mjs
  var hostOrigin = parent !== window ? parent.location.origin : location.origin;
  var media = JSON.parse(document.getElementById("circuit-assets").textContent);
  var el = (id) => document.getElementById(id);
  var canvas = el("scene");
  var ctx = canvas.getContext("2d", { alpha: false });
  var reduced = matchMedia("(prefers-reduced-motion: reduce)");
  var state = createState({ demo: false, paused: true });
  var assets = {};
  var last = 0;
  var uiTime = 0;
  var frames = 0;
  var lastStatus = "";
  var started = false;
  var menuOpen = true;
  var pointerY = null;
  function resize() {
    const scale = canvas.clientWidth / W;
    el("hud").style.setProperty("--dot-step", 8 * scale + "px");
    el("hud").style.setProperty("--dot-radius", 2.2 * scale + "px");
    const width = Math.max(1, Math.min(W, Math.round(canvas.clientWidth * Math.min(devicePixelRatio, 2))));
    canvas.width = width;
    canvas.height = Math.round(width * H / W);
    if (assets.glyphs) draw(ctx, assets, state, canvas.width, canvas.height);
  }
  function focusGame() {
    canvas.focus({ preventScroll: true });
  }
  function showMenu(kind = "pause", focus = true) {
    setPaused(state, true);
    menuOpen = true;
    el("menu-panel").hidden = false;
    el("hud").inert = true;
    canvas.tabIndex = -1;
    const ended = !["racing", "crashing"].includes(state.status);
    el("menu-title").textContent = kind === "start" ? "BOXBOX CIRCUIT" : state.status === "crashed" ? "CONTACT" : "PAUSED";
    el("menu-detail").textContent = kind === "start" ? "Find a gap. Boost past traffic. Keep racing." : state.status === "crashed" ? "A little too close. Find your gap and go again." : "Your run is waiting.";
    el("resume").hidden = !started || ended;
    el("play-label").textContent = started ? "RACE AGAIN" : "START RACE";
    el("play").classList.toggle("primary", !started || ended);
    if (focus) (el("resume").hidden ? el("play") : el("resume")).focus({ preventScroll: true });
    ui();
  }
  function hideMenu() {
    menuOpen = false;
    el("menu-panel").hidden = true;
    el("hud").inert = false;
    canvas.tabIndex = 0;
    setPaused(state, false);
    last = 0;
    focusGame();
    ui();
  }
  function ui() {
    const racing = state.status === "racing", status = boostStatus(state);
    el("area").textContent = "COTA / 0" + (state.sector + 1);
    el("phase").textContent = state.demo ? "DEMO \xB7 " + SECTORS[state.sector].name : SECTORS[state.sector].name;
    el("boost").dataset.state = status;
    el("boost-state").textContent = status === "WAIT" ? "CHARGING" : status;
    el("up").disabled = !racing || state.lane === 0;
    el("down").disabled = !racing || state.lane === 2;
    el("boost").disabled = !racing || state.time < state.cooldownUntil;
    const charge = status === "LIVE" ? (state.boostUntil - state.time) / BOOST_SECONDS : status === "WAIT" ? 1 - (state.cooldownUntil - state.time) / (BOOST_CYCLE - BOOST_SECONDS) : status === "OFF" ? 0 : 1;
    el("charge").style.setProperty("--charge", Math.max(0, charge) * 100 + "%");
    if (state.status !== lastStatus) {
      el("announcement").textContent = state.phase;
      lastStatus = state.status;
    }
    Object.assign(canvas.dataset, { mode: state.demo ? "demo" : "manual", running: String(!state.paused), lane: String(state.lane + 1), boost: status, distance: state.distance.toFixed(2), wheelPhase: (state.distance / 45.6).toFixed(3), frames: String(frames), status: state.status, sector: String(state.sector + 1), speed: state.speed.toFixed(2), menu: String(menuOpen), left: remaining(state).toFixed(1), time: state.time.toFixed(1), traffic: String(state.opponents.length), waves: String(state.spawnCount) });
  }
  function act(name) {
    if (["play", "demo", "crash"].includes(name)) {
      state = name === "crash" ? crashPreview() : createState({ demo: name === "demo" });
      started = true;
      hideMenu();
    }
    if (name === "resume") hideMenu();
    if (name === "menu") showMenu();
    if (name === "how") {
      el("help").hidden = !el("help").hidden;
      el("how").setAttribute("aria-expanded", String(!el("help").hidden));
    }
    if (name === "exit" || name === "close") {
      showMenu(started ? "pause" : "start", false);
      if (parent !== window) parent.postMessage({ type: "boxbox-circuit-close" }, hostOrigin);
      else location.href = "/";
    }
    if (!menuOpen) {
      if (name === "up") steer(state, -1);
      if (name === "down") steer(state, 1);
      if (name === "boost") boost(state);
    }
    last = 0;
    ui();
    if (assets.glyphs) draw(ctx, assets, state, canvas.width, canvas.height);
  }
  for (const id of ["up", "down", "boost", "menu", "resume", "play", "demo", "how", "exit", "close"]) el(id).addEventListener("click", (event) => {
    act(id);
    if (!menuOpen && event.detail > 0) focusGame();
  });
  canvas.addEventListener("pointerdown", (e) => {
    pointerY = e.clientY;
    canvas.setPointerCapture(e.pointerId);
    focusGame();
  });
  canvas.addEventListener("pointerup", (e) => {
    if (pointerY !== null && Math.abs(e.clientY - pointerY) > 18) act(e.clientY > pointerY ? "down" : "up");
    pointerY = null;
  });
  canvas.addEventListener("pointercancel", () => pointerY = null);
  window.addEventListener("keydown", (e) => {
    if (e.code === "Tab") {
      const candidates = menuOpen ? [...el("menu-panel").querySelectorAll("button"), el("close")] : [canvas, ...el("hud").querySelectorAll("button"), el("close")], buttons = candidates.filter((b) => !b.hidden && !b.disabled && b.getClientRects().length), first = buttons[0], last2 = buttons.at(-1);
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last2.focus();
      } else if (!e.shiftKey && document.activeElement === last2) {
        e.preventDefault();
        first.focus();
      }
      return;
    }
    if (e.code === "Escape") {
      e.preventDefault();
      if (!e.repeat) act("close");
      return;
    }
    if (e.code === "KeyP") {
      e.preventDefault();
      if (e.repeat) return;
      if (menuOpen && started && ["racing", "crashing"].includes(state.status)) hideMenu();
      else if (!menuOpen) showMenu();
      return;
    }
    if (menuOpen || e.target.closest('input,textarea,select,[contenteditable="true"]')) return;
    const name = { ArrowUp: "up", KeyW: "up", ArrowDown: "down", KeyS: "down", Space: "boost" }[e.code];
    if (!name) return;
    if (e.code === "Space" && e.target.closest("button,a")) return;
    e.preventDefault();
    if (!e.repeat) act(name);
  });
  document.addEventListener("visibilitychange", () => {
    last = 0;
    if (document.hidden && started) showMenu("pause", false);
  });
  window.addEventListener("message", (e) => {
    if (e.origin !== hostOrigin || e.source !== parent) return;
    if (e.data?.type === "boxbox-circuit-pause") showMenu(started ? "pause" : "start", false);
    if (e.data?.type === "boxbox-circuit-focus") (el("resume").hidden ? el("play") : el("resume")).focus({ preventScroll: true });
  });
  reduced.addEventListener("change", () => {
    if (reduced.matches) showMenu(started ? "pause" : "start");
    el("motion-note").hidden = !reduced.matches;
  });
  el("motion-note").hidden = !reduced.matches;
  new ResizeObserver(resize).observe(canvas);
  async function start() {
    await Promise.all(["hills", "landmarks", "trees", "upper-verge", "lower-verge", "hud-top", "hud-bottom", "aston", "pale", "grey"].map(async (name) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src = media[name];
      await img.decode();
      assets[name] = img;
    }));
    assets.glyphs = glyphs_default;
    preparePalette(assets, (w, h) => {
      const c = document.createElement("canvas");
      c.width = w;
      c.height = h;
      return c;
    });
    resize();
    showMenu("start", false);
    el("loading").remove();
    function frame(now) {
      const dt = last ? Math.min(0.05, (now - last) / 1e3) : 0;
      last = now;
      if (!document.hidden && !state.paused && ["racing", "crashing"].includes(state.status)) {
        step(state, dt);
        draw(ctx, assets, state, canvas.width, canvas.height);
        frames++;
        if (!["racing", "crashing"].includes(state.status)) showMenu("end");
        else if (now - uiTime > 80) {
          ui();
          uiTime = now;
        }
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
  start().catch((error) => {
    el("loading").textContent = "Game could not load.";
    el("error").textContent = error.message;
  });
})();
